import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';

export class TagGroup extends Model<Schemas['tagGroups'], Models> {}
